import dep from "../assets/dep.jpg";
import bt from "../assets/bt.jpg";
import im from "../assets/images.png";
import sk from "../assets/skincare-cleanse.jpg";
import ad from "../assets/adoption.png"
import dt from "../assets/dti.jpg"
const Workcarddata=[
    {
        imgsrc:dt,
        title:"Blue's Meter",
        view:"https://www.linkedin.com/in/snekhasuresh21/",
        text:"MRI / CT Scans take a lot to time for diagnosis. In our AI powered solution we provide automatic diagnosis using ML & Advanced AI ."
    },
    {
        imgsrc:sk,
        title:"Cutis Care",
        view:"https://www.linkedin.com/in/snekhasuresh21/",
        text:"An exclusive all in one skin care app to diagnose skin diseases and find right shade for cosmetics along with proper follow ups with dermatologists"
    },
    {
        imgsrc:ad,
        title:"Adopt AI",
        view:"https://www.linkedin.com/in/snekhasuresh21/",
        text:"An automated website to enhance child Reduces burdens, and ultimately facilitate more successful placements of children into loving homes"
    },
    {
        imgsrc:ad,
        title:"Anti-Amnio",
        view:"https://www.linkedin.com/in/snekhasuresh21/",
        text:"Amniocentesis is a procedure performed on pregnant mothers to check for genetic disorders in foetus.An alternative to amniocentesis using machine learning (ML) techniques for non-invasive prenatal testing (NIPT)"
    },
    {
        imgsrc:ad,
        title:"Trauma-AI",
        view:"https://www.linkedin.com/in/snekhasuresh21/",
        text:"Numerous accidents take place everyday and a huge number of trauma patients are taken to a hospital where there isn't enough time to analyse the depth of trauma. ML Based Degree of Trauma Diagnosis."
    },
];
export default Workcarddata;